<ng-container *ngIf="item.show">
  <ion-menu-toggle  class="item" [class.rounded]="rounded" [autoHide]="false" *ngIf="!item.childreen || item.childreen.length === 0">
    <ion-item class="pointer" (click)="item.onClick && item.onClick()" lines="none" detail="false"
      [class.selected]="item.url === navService.currentUrl">
      <ion-icon class="ion-no-margin" style="margin-right: 4px;" *ngIf="item.icon" slot="start" [ios]="item.icon + '-outline'" [md]="item.icon + '-sharp'"></ion-icon>
      <ion-label class="ion-text-wrap small-text">{{ item.label | translate }}</ion-label>
    </ion-item>
  </ion-menu-toggle>
  <div class="item sub" [class.rounded]="rounded" [class.expanded]="item.expanded" *ngIf="item.childreen && item.childreen.length > 0">
    <ion-item class="pointer"  (click)="item.onClick && item.onClick()" lines="none" detail="false"
      [class.selected]="hasChildSelected">
      <ion-icon class="ion-no-margin"  style="margin-right: 4px;" *ngIf="item.icon" slot="start" [ios]="item.icon + '-outline'" [md]="item.icon + '-sharp'"></ion-icon>
      <ion-label class="ion-text-wrap small-text">{{ item.label | translate}}</ion-label>
      <ion-icon slot="end" [name]="!item.expanded ? 'chevron-down': 'chevron-up'"></ion-icon>
    </ion-item>
    <ion-card-content *ngIf="item.expanded">
      <ion-list>
        <ion-menu-toggle *ngFor="let sub of item.childreen" class="item" [autoHide]="false">
          <app-menu-item [rounded]="rounded" [item]="sub"></app-menu-item>
        </ion-menu-toggle>
      </ion-list>
    </ion-card-content>
  </div>
</ng-container>